import { IndividualWithProfessionType } from "../../types/commonTypes/individualWithProfessionType";

export const individualWithProfessionInitialState: IndividualWithProfessionType = {
    civility: "Monsieur",
    lastName: "",
    firstName: "",
    profession: "",
    birthName: "",
    nationality: ""
}